import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/interfaceLog/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/interfaceLog/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/interfaceLog/updateById', data)
}
